import { jsxs as i, jsx as n } from "react/jsx-runtime";
import c from "clsx";
import { IconQuadStar as l } from "../Icon/24/IconQuadStar.js";
import { Typography as g } from "../Typography/Typography.js";
import '../../theme.css';import '../../_assets/Tag.D2yGplvq.css';/* empty css                                          */
var d = "Tag_tag__9l0yd40", y = "Tag_content__9l0yd41", p = { s: "Tag_iconSize_s__9l0yd42", l: "Tag_iconSize_l__9l0yd43" }, m = { neutral: "Tag_variant_neutral__9l0yd44", default: "Tag_variant_default__9l0yd45", success: "Tag_variant_success__9l0yd46", secondary: "Tag_variant_secondary__9l0yd47", warning: "Tag_variant_warning__9l0yd48", emphasis: "Tag_variant_emphasis__9l0yd49" };
const u = {
  brown: "neutral",
  stone: "default",
  "go-green": "success",
  orange: "warning",
  "sky-blue": "emphasis",
  "light-green": "secondary"
}, w = ({
  children: r,
  type: t = "stone",
  size: a = "s",
  className: s,
  showIcon: e = !0
}) => {
  const _ = u[t], o = a === "s" ? "1" : "2";
  return /* @__PURE__ */ i("span", { className: c(d, m[_], s), children: [
    e && /* @__PURE__ */ n(l, { className: p[a] }),
    /* @__PURE__ */ n(
      g,
      {
        variant: "captionMono",
        size: o,
        className: y,
        component: "span",
        noPadding: !0,
        children: r
      }
    )
  ] });
};
export {
  w as Tag
};
